module.exports = __webpack_public_path__ + "static/media/before-after.353799b8.png";